import { Record } from "immutable";

export type ContentModuleMetaType = {
  moduleId: string;
  timesStudied: number;
  timesTested: number;
  timesCorrect: number;
  timesIncorrect: number;
  timesGivenUp: number;
  lastStudied: string;
  lastScore: number | null | undefined;
  averageScore: number | null | undefined;
};

export default class ContentModuleMeta extends Record({
  moduleId: undefined,
  timesStudied: 0,
  timesTested: 0,
  timesCorrect: 0,
  timesIncorrect: 0,
  timesGivenUp: 0,
  lastStudied: null,
  lastScore: null,
  averageScore: null
}) {}
